import { render, staticRenderFns } from "./RegisterFromInvite.vue?vue&type=template&id=15ad22d4&scoped=true&"
import script from "./RegisterFromInvite.vue?vue&type=script&lang=js&"
export * from "./RegisterFromInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ad22d4",
  null
  
)

export default component.exports